function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 0C2.691 0 0 2.362 0 5.267C0 8.172 2.691 10.533 6 10.533C6.34684 10.5331 6.69319 10.5067 7.036 10.454L9.761 11.939C9.8344 11.9788 9.91652 11.9997 10 12C10.1326 12 10.2598 11.9473 10.3536 11.8536C10.4473 11.7598 10.5 11.6326 10.5 11.5V8.711C10.9646 8.26406 11.3363 7.72972 11.5937 7.13868C11.8511 6.54765 11.9892 5.91157 12 5.267C12 2.362 9.309 0 6 0Z",
  fill: "white"
});

var SvgTextBubble = function SvgTextBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTextBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/text_bubble.c8b5c19f.svg";
export { ForwardRef as ReactComponent };